// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Higher specificity than .ta-workspace-reports-span's \`color: black !important\`, so the
   active/in-view color wins regardless of stylesheet order. */
.tab.tab-selected {
  font-style: italic;
  color: #0080ab !important;
}
.tab-open {
  font-style: italic;
}
.tab-unselected {
  border: none;
  color: black;
  background: white;
  padding-top: 2px;
  padding-bottom: 2px;
}
.tab-unselected:hover {
  color: black;
  background-color: #cfeaf8;
}
.tab {
  height: 100%;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
}
.close-report-icon > svg {
  fill: rgba(88, 89, 91, 1);
  margin-bottom: 2px;
}
.close-report-icon:hover > svg {
  fill: black;
}
.close-no-show {
  display: none;
}

/* Nav-dropdown rows (root reports, folder headers, folder/subfolder reports) are capped
   at 400px wide (see .nav-dropdown) — these let a row's fixed-size icon/close-button
   keep their size while the name itself truncates with an ellipsis instead of forcing
   the dropdown wider or wrapping. */
.nav-item-row {
  display: flex;
  align-items: center;
  min-width: 0;
}
.nav-item-icon-slot {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.nav-item-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/topLevelNav/components/topLevelNavItem/style/style.css"],"names":[],"mappings":"AAAA;8DAC8D;AAC9D;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;;;oCAGoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["/* Higher specificity than .ta-workspace-reports-span's `color: black !important`, so the\n   active/in-view color wins regardless of stylesheet order. */\n.tab.tab-selected {\n  font-style: italic;\n  color: #0080ab !important;\n}\n.tab-open {\n  font-style: italic;\n}\n.tab-unselected {\n  border: none;\n  color: black;\n  background: white;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n.tab-unselected:hover {\n  color: black;\n  background-color: #cfeaf8;\n}\n.tab {\n  height: 100%;\n  padding-left: 10px;\n  padding-right: 10px;\n  cursor: pointer;\n}\n.close-report-icon > svg {\n  fill: rgba(88, 89, 91, 1);\n  margin-bottom: 2px;\n}\n.close-report-icon:hover > svg {\n  fill: black;\n}\n.close-no-show {\n  display: none;\n}\n\n/* Nav-dropdown rows (root reports, folder headers, folder/subfolder reports) are capped\n   at 400px wide (see .nav-dropdown) — these let a row's fixed-size icon/close-button\n   keep their size while the name itself truncates with an ellipsis instead of forcing\n   the dropdown wider or wrapping. */\n.nav-item-row {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n.nav-item-icon-slot {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n.nav-item-label {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
